module.exports = __webpack_public_path__ + "static/media/29COICT1.8a8e9694.jpg";